


export class CostReviewSecurityEnUsCctvSystems {
  isCCTVSystemsChecked!: boolean;
  integrationWithOtherSystems!: number;
  isNewVendorChecked!: boolean;
  newVendor!: string;
  isReplacementVendorChecked!: boolean;
  replacementVendor!: string;
  isExpansionVendorChecked!: boolean;
  expansionVendor!: string;
  serverProvidedBy!: number;
  storageProvidedBy!: number;
  clientComputer!: number;
  numberOfClients!: number;
  integrationRequired!: number[];
  liftRequired!: number;
  risk!: string;
  numberOfControllers!: number;
  numberOfInsideCameras!: number;
  numberOfOutsideCameras!: number;
  panAndTiltCameras!: number;
  expectedStorageTime!: number;
  archivingMedia!: number;
  employeesToTrain!: number;
  lowContractor!: string;
  numberOfBidders!: number;
}
